import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { UpdateCalendarService } from './services/update-calendar-api-service';
import { TemaPageDto } from '@jobindsats/typescript-fetch-jobindsats';

@customElement('ji-update-calendar-element-mobile')
export class UpdateCalendarElementMobile extends JobindsatsElement(LitElement) {
    static styles = [
        css`
            .element-header-text {
                padding-top: 25px;
            }

        `
    ];

    static instance = 0;

    @property({
        attribute: 'maaling-id'
    })
    maalingId?: string;

    @property({
        attribute: 'maaling-url'
    })
    maalingUrl?: string;

    @property({
        attribute: 'maaling-name'
    })
    maalingName?: string;

    @property({
        attribute: 'group-name'
    })
    groupName?: string;

    @property({
        attribute: 'id',
    })
    id = ++UpdateCalendarElementMobile.instance + 'lit-calendar-element-mobile';

    @state()
    metadataMaaling?: TemaPageDto;

    maalingService: UpdateCalendarService;

    constructor() {
        super();
        this.maalingService = new UpdateCalendarService();
    }


    connectedCallback() {
        super.connectedCallback();
        if (this.maalingId) {
            this.maalingService.getMetadataMaalingValues({ maalingId: this.maalingId }).then(res => {
                this.metadataMaaling = res;

                this.showCalendar();
            });
        }
    }

    render() {
        var lastPeriod = 'Ingen periode angivet';

        if (this.metadataMaaling?.period?.firstAndLast) {
            lastPeriod = this.metadataMaaling.period?.firstAndLast[1];
        }

        if (this.metadataMaaling) {
            return html`
                <div id="${this.id}">
                    <div class="element-header-text">MÅLINGSGRUPPE</div>
                    <div >${this.groupName}</div>

                    <div class="element-header-text">MÅLING</div>
                    <a href=${this.maalingUrl}>${this.maalingName}</a>

                    <div class="element-header-text">OPDATERET</div>
                    <div >${this.metadataMaaling.updateInfo?.lastUpdate?.toLocaleDateString('da-DK', { year: "numeric", month: "short", day: "numeric" })}</div>

                    <div class="element-header-text">NÆSTE OPDATERING</div>
                    <div >${this.metadataMaaling.updateInfo?.nextUpdate?.toLocaleDateString('da-DK', { year: "numeric", month: "short", day: "numeric" })}</div>

                    <div class="element-header-text">SENESTE PERIODE</div>
                    <div >${lastPeriod} </div>

                    <div class="element-header-text">OPDATERINGSFREKVENS</div>
                    <div >${this.metadataMaaling.updateFreq}</div>
                </div>

        `;
        }
    }

    showCalendar() {
        document.getElementById('UpdateCalendar')?.classList.remove('calendar-hidden');
    }
}